(function() {
  'use strict';

  function UserEventsController($scope, $rootScope,
                                Profile, EventUtils, OrganisationsService, $translate, Utils,
                                Security, UsersStub, $log) {
    var ctrl = this;

    ctrl.todoOptions = {
      trackBy: 'id',
      hideEndOfListText: true
    };

    ctrl.$onChanges = function() {
      ctrl.options = {
        // highlightField: 'text'
        highlightField: 'name',
        typesToUpdate: ['event', 'eventSection'],
        trackBy: 'id',
        borderClass: function(item) {
          return item.main.getBorderClass();
        }
      };
      if (ctrl.filterId) {
        OrganisationsService.getFilter('epf.events.index', ctrl.filterId)
          .then(function(data) {
            ctrl.resolvedFilter = data;
            ctrl.setup();
          })
          .catch(function(error) {
            $log.warn(error);
          });
      } else {
        ctrl.setup();
      }
    };

    function setupTodoList() {
      return EventUtils.getList('todosearch', ctrl.searchModel, {
        own: true,
        defaultFilter: {
          extendedState: ['draft'],
          eventOwner: ctrl.username
        },
        listOptions: {
          maxSize: 5
        }
      }).then(function(list) {
        ctrl.sectionList = list;
        return ctrl.sectionList.doLoadItems();
      });
    }

    ctrl.setup = function() {
      ctrl.actions = [
        {
          label: $translate.instant('Create new'),
          icon: 'icon-plus',
          route: ['/events/new', ctrl.user],
          showCondition: Security.hasPermissionFor.bind(this, 'events.create', ctrl.user),
          klass: 'btn-success'
        }
      ];
      var listName = ctrl.resolvedFilter ? 'userevents-' + ctrl.resolvedFilter.id : 'userevents';
      ctrl.username = ctrl.user;
      if (_.isEmpty(ctrl.username)) {
        Utils.unauthorized(
          { message: 'You are not authorised to access this page. User is not defined.' }
        );
        Utils.setPageTitle('User events');
      } else {
        UsersStub.find(ctrl.username)
          .then(function(user) {
            var fullName = _.trim(
              (user.firstName || '') + ' ' + (user.lastName || '')
            );
            Utils.setPageTitle(fullName + '\'s events');
          })
          .catch(function() {
            Utils.setPageTitle('User events');
          });
      }

      setupTodoList()
      .then(EventUtils.preCache)
      .then(function() {
        var defaultFilter = _.assignIn(
          {},
          { user: ctrl.username }
        );

        ctrl.searchModel = Profile.getListPreferences(listName).current;
        ctrl.options.search = ctrl.searchModel;
        var searchCode = 'usersearch';
        return EventUtils.getList(
          searchCode,
          ctrl.searchModel,
          {
            own: false,
            defaultFilter: defaultFilter,
            resolvedFilter: ctrl.resolvedFilter
          }
        );
      })
      .then(function(list) {
        ctrl.list = list;
        $rootScope.$broadcast('KZCurrentListChange', { list: listName, search: ctrl.list.search });
        $rootScope.loading = false;
        ctrl.list.doLoadItems();
        ctrl.loaded = true;
      });
    };

    $scope.$on('KZStoreInvalidated', function(_evt, args) {
      if (args.type === 'event' || args.type === 'eventSection') {
        setupTodoList();
      }
    });
  }

  UserEventsController.$inject = [
    '$scope',
    '$rootScope',
    'ProfileService',
    'EventUtils',
    'OrganisationsService',
    '$translate',
    'UtilsService',
    'SecurityService',
    'UsersStubService',
    '$log'
  ];

  angular.module('component.users')
    .component('userEvents', {
      controller: UserEventsController,
      controllerAs: 'eventsCtrl',
      templateUrl: 'app/components/users/eventlist.html',
      bindings: {
        filterId: '<',
        user: '<'
      }
    });
})();
